import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { 
  OauthService,
  AccountSettingService,
  I18nService,
  BrowserUtils
} from '@terradotta/commons';
import { TDAccountSetting } from '@terradotta/commons';
import { CSSUtils } from '@terradotta/commons';
import { TimeUtils } from '@terradotta/commons';

declare var $: any;

@Component({
  selector: 'app-program-discovery-page',
  templateUrl: './program-discovery-page.component.html',
  styleUrls: ['./program-discovery-page.component.scss']
})
export class ProgramDiscoveryPageComponent implements OnInit, AfterViewInit{

  dateFormat: string;
  momentDateFormat: string;
  iCurrencyMask: string = '';
  queryParams: any;
  programDiscoveryTitle: string = '';
  searchHelpText: string = '';
  @Input() showprogramtypefilter = undefined;
  @Input() search = undefined;
  token:any;

  constructor(private snackbar: MatSnackBar, 
    private route: ActivatedRoute,
    private _oauthService: OauthService,
    private _accountSettingService: AccountSettingService,
    private _i18nService: I18nService) { }

  ngOnInit() {
    console.log(typeof this.showprogramtypefilter + '-' + this.showprogramtypefilter);
    this.showprogramtypefilter = (this.showprogramtypefilter === 'true');
    console.log(typeof this.showprogramtypefilter + '-' + this.showprogramtypefilter);

    console.log(this.search);
    
    // this.showprogramtypefilter = true;//test
    // this.search = '[{"filterType":"programDiscoveryKeyword","filterValues":[{"value":"test program"}]}]';//test

    var that = this;
    // removing the keydown listener from bootstrap preventing the 
    // single/multi-select arrow key navigation
    var listeners = $._data(document,'events');
    //listeners.keydown.pop();
    
    that._oauthService.getToken().then((resp:any) => {
      // that.token = resp;
      // console.log(resp);
      that.route.queryParams.subscribe(data => {
        that.queryParams = data;
        that.loadI18nWords();
        that.loadAccountSettings();
      });
    });
  }

  ngAfterViewInit(){
    BrowserUtils.fixSkipToContent();
  }

  loadI18nWords(): void {
    var that = this;
    that._i18nService.getWords([10204,10203]).subscribe(resp => {
      resp.forEach(w => {
        switch(w.id){
          case 10204:
            that.programDiscoveryTitle = w.word;
            break;
          case 10203:
            that.searchHelpText = w.word;
            break;
        }
      })
    })
  }

  loadAccountSettings(){
    this._accountSettingService.getByNames(['_sCustomColor', '_sColorCSS', '_sDateMaskOutput', '_sCFLocale']).subscribe(resp => {
      if (resp && resp['_sCustomColor']) {
        var customColor = resp['_sCustomColor'].activeValue;
        if(customColor && customColor !== ''){
          this.fixColors(customColor);
        } 
      } 
      if (resp && resp['_sColorCSS'] && !resp['_sCustomColor']) {
        var color = CSSUtils.defaultColorsMap(resp['_sColorCSS'].activeValue);
        this.fixColors(color);
      }
      if (resp && resp['_sDateMaskOutput']) {
        this.dateFormat = TimeUtils.tdsToJavascriptFormat(resp['_sDateMaskOutput'].activeValue);
        this.momentDateFormat = TimeUtils.tdsToMomentFormat(resp['_sDateMaskOutput'].activeValue);
      }
      if (resp && resp['_sCFLocale']) {
        this.iCurrencyMask = resp['_sCFLocale'].activeValue;
      }
    }, () => {
      this.snackbar.open('Oops we got an error, try again later.', 'Dismiss', { duration: 4000 });
    });

    // this._accountSettingService.getByName('_sCustomColor').subscribe((resp: TDAccountSetting) => {
    //   if(resp){
    //     var customColor = resp.settingValue;
    //     if(customColor && customColor !== ''){
    //       this.fixColors(customColor);
    //     } 
    //     else {
    //       this._accountSettingService.getByName('_sColorCSS').subscribe((resp: TDAccountSetting) => {
    //         if(resp){
    //           var color = CSSUtils.defaultColorsMap(resp.settingValue);
    //           this.fixColors(color);
    //         }
    //       },err => {
    //         this.fixColors(null);
    //       });
    //     }
    //   }
    // },err => {
    //   this._accountSettingService.getByName('_sColorCSS').subscribe((resp: TDAccountSetting) => {
    //     if(resp){
    //       var color = CSSUtils.defaultColorsMap(resp.settingValue);
    //       this.fixColors(color);
    //     }
    //   },err => {
    //     this.fixColors(null);
    //   });
    // });
    // this._accountSettingService.getByName('_sDateMaskOutput').subscribe((resp: TDAccountSetting) => {
    //   if(resp){
    //     this.dateFormat = TimeUtils.tdsToJavascriptFormat(resp.settingValue);
    //     this.momentDateFormat = TimeUtils.tdsToMomentFormat(resp.settingValue);
    //   }
    // });
    // this._accountSettingService.getByName('_sCFLocale').subscribe((resp: TDAccountSetting) => {
    //   if(resp){
    //     this.iCurrencyMask = resp.settingValue;
    //   }
    // });
  }

  fixColors(primary){
    CSSUtils.fixPrimaryColor(primary);
  }

}